import React from "react";
import { Link } from "react-router-dom";

const TopHeader = ({ subtitle, title }) => {
  return (
    <div className="font-serif  mx-auto max-w-6xl w-full">
      {/* Background section */}

      <div className="relative z-10  text-white text-sm font-semibold">
        <h1 className="uppercase">bunda Investment: {title}</h1>
      </div>

      {/* Main Banner Content */}
      <div className="bg-white shadow-md rounded relative z-20">
        <div className="flex justify-between items-center px-6 py-6">
          <h1 className="text-2xl md:text-3xl font-semibold text-slate-700 capitalize">
            {subtitle}
          </h1>
          <Link
            to="/apply-loan"
            className="bg-amber-500 hover:opacity-90 text-white text-sm font-semibold px-5 py-2 rounded"
          >
            APPLY
          </Link>
        </div>

        {/* Sub Tabs */}
        <div className="flex border-t border-gray-200 text-sm text-slate-500 font-medium divide-x">
          <Link to="/contact-us" className={"flex-1 px-4 py-3 text-center "}>
            GIVE US A CALL BACK
          </Link>
          <Link
            to="/loan-calculator"
            className={"flex-1 px-4 py-3 text-center uppercase "}
          >
            loan calculator
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
